import React from 'react';
import styled from 'styled-components';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Navbar from "./Navbar";
import Jobs from "./components/jobs/Jobs";
import Login from "./components/Login";
import DeploymentsList from "./components/DeploymentsList";
import {createGlobalStyle} from 'styled-components';
import PipelineBuilder from "./components/pipeline-builder/PipelineBuilder";
import TaskEditor from "./components/tasks/tasks";
import Settings from "./components/Settings";
import Users from "./components/Users/Users";
import Server from "./components/server/Server";
import TestResultsView from "./components/jobs/details/TestResultsView";
import Simulations from "./components/simulations/Simulations";

function About() {
    return <h2>About</h2>;
}

const Container = styled.div`


`

const GlobalStyle = createGlobalStyle`
    :root {
        /* Primary Blue */
        --primary-blue: #1E3A8A;
        --primary-blue-hover: #2C5282;
        --primary-blue-selected: #3B82F6;
        --primary-blue-selected-hover: #2563EB;

        /* Secondary Blue */
        --secondary-blue: #1E40AF;
        --secondary-blue-hover: #1D4ED8;
        --secondary-blue-selected: #60A5FA;
        --secondary-blue-selected-hover: #3B82F6;

        /* Accent Blue */
        --accent-blue: #0F172A;
        --accent-blue-hover: #1E293B;
        --accent-blue-selected: #334155;
        --accent-blue-selected-hover: #475569;

        --content-box-bg: #161B22; /* Content box background */
        --content-box-border: #30363D; /* Content box border */

        /* Text Colors */
        --text-primary: #C9D1D9; /* Primary text */
        --text-secondary: #8B949E; /* Secondary text */

        /* Hover and Active States */
        --content-box-hover: #1C2128; /* Hover state for content boxes */
        --content-box-active: #21262D; /* Active state for content boxes */
    }
`;

function App() {

    return (
        <Container>
            <GlobalStyle></GlobalStyle>
            <Router>
                <Navbar/>
                <Routes>
                    <Route path="/" element={<Jobs/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/deployments" element={<DeploymentsList/>}/>
                    <Route path="/pipeline-builder" element={<PipelineBuilder/>}/>
                    <Route path="/tasks" element={<TaskEditor/>}/>
                    <Route path="/servers" element={<Server/>}/>
                    <Route path="/users" element={<Users/>}/>
                    <Route path="/settings" element={<Settings/>}/>
                    <Route path="/test-results" element={<TestResultsView/>}/>
                    <Route path="/simulations" element={<Simulations/>}/>
                </Routes>
            </Router>
        </Container>
    );
}

export default App;
